import { extractApiError } from '../services';

/** Extrae un mensaje legible para mostrar al usuario a partir de cualquier error. */
export function resolveErrorMessage(err: unknown): string {
	return extractApiError(err);
}
